import { ChevronRight } from '@ixigo/icons';
import { Carousel, CarouselItem } from '@ixigo/iui/Carousel';
import Dialog from '@ixigo/iui/Dialog';
import clsx from 'clsx';
import { FC, Fragment } from 'react';
import BookingCard from '../BookingCard';
import DesktopSlide from '../DesktopSlide';
import DialogHeader from '../DialogHeader';
import { BookingCarouselProps } from './index.types';

const controlBtnClass =
    'relative inline-flex justify-center items-center w-40 h-40 text-primary-500 bg-white rounded-full shadow-500';

const WebBookingCarousel: FC<BookingCarouselProps> = ({ bookings, onClick, recentBookings, setViewAll, viewAll }) => (
    <>
        <Carousel
            className='relative scroll-p-30'
            nextControlIcon={
                <span className={clsx(controlBtnClass, 'right-30')}>
                    <ChevronRight />
                </span>
            }
            prevControlIcon={
                <span className={clsx(controlBtnClass, 'left-30')}>
                    <ChevronRight className='rotate-180' />
                </span>
            }
            buttonControls
        >
            {recentBookings.map((booking) => (
                <CarouselItem
                    key={booking.bookingId}
                    className='w-[calc(25%-30px)] my-20 p-10 bg-white shadow-100 cursor-pointer first-of-type:ml-30 last-of-type:mr-30'
                >
                    <BookingCard bookingData={booking} onClick={() => onClick(booking)} />
                </CarouselItem>
            ))}
        </Carousel>
        <Dialog
            classes={{ container: 'h-full !rounded-none', root: '!justify-end' }}
            onClose={() => setViewAll(false)}
            open={viewAll}
            TransitionComponent={DesktopSlide}
        >
            <div className='w-27.5'>
                <DialogHeader onClose={() => setViewAll(false)} title='Select your booking' />
                <div className='flex flex-col px-30 py-20 gap-15'>
                    {bookings.map((booking) => (
                        <Fragment key={booking.bookingId}>
                            <div className='p-10 shadow-100 rounded-20 cursor-pointer'>
                                <BookingCard bookingData={booking} onClick={() => onClick(booking)} />
                            </div>
                        </Fragment>
                    ))}
                </div>
            </div>
        </Dialog>
    </>
);

export default WebBookingCarousel;
